import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { canAccess, clearReturnUrl, rememberReturnUrl } from '../_helpers';

export { PrivateRoute };

function PrivateRoute({ children }) {
    const { user: authUser } = useSelector(x => x.auth);
    const location = useLocation();
    const allowed = canAccess(location.pathname, authUser);

    useEffect(() => {
        if (allowed) clearReturnUrl();
    }, [allowed]);

    if (!authUser) {
        // Store before <Navigate> runs. Its redirect is an effect, so a later
        // effect would be too late to keep the page the user asked for.
        const returnPath = rememberReturnUrl(location);
        return (
            <Navigate
                to="/login"
                replace
                state={returnPath ? { from: returnPath } : undefined}
            />
        );
    }

    if (!allowed) {
        return <Navigate to="/" replace />;
    }

    return children;
}
